"use client";

import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:propstrata-app": true
    });
  } catch (e) {}
}();
import { Check, Minus } from "lucide-react";
import { WORKSPACE_PERMISSION_RESOURCE_LABELS, type WorkspacePermissionResourceKey } from "@/lib/constants/workspace-permission-resources";
import { cn } from "@/lib/utils";
import type { Permission } from "@/types/permissions";
export const defaultEntityPermissions = [{
  key: "canCreate" as keyof Permission,
  label: "Create"
}, {
  key: "canEdit" as keyof Permission,
  label: "Edit"
}, {
  key: "canView" as keyof Permission,
  label: "View"
}, {
  key: "canDelete" as keyof Permission,
  label: "Delete"
}];
export function PermissionsList(t0) {
  const $ = _c(4);
  const {
    permissions
  } = t0;
  let t1;
  if ($[0] !== permissions) {
    t1 = permissions.map(_temp);
    $[0] = permissions;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="grid divide-y divide-border border rounded-lg">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(permission) {
  const activeCount = [permission.canView, permission.canCreate, permission.canEdit, permission.canDelete].filter(Boolean).length;
  const permissionName = WORKSPACE_PERMISSION_RESOURCE_LABELS[permission.name as WorkspacePermissionResourceKey];
  const permissionCountMessage = activeCount === defaultEntityPermissions.length ? "All" : `${activeCount} of ${defaultEntityPermissions.length}`;
  return <div className="flex items-center justify-between px-4 py-2.5" key={permission.name}><div className=""><p className="font-medium text-sm capitalize">{permissionName}</p><p className="text-xs text-muted-foreground">{`(${permissionCountMessage} permissions)`}</p></div><div className="flex gap-6">{defaultEntityPermissions.map(entity => {
        const hasPermission = permission[entity.key];
        return <div className="text-center" key={entity.key}><div className="text-xs text-muted-foreground mb-1">{entity.label}</div><div className={cn("size-6 rounded-full flex items-center justify-center", hasPermission ? "bg-emerald-100" : "bg-muted")}>{hasPermission ? <Check className="size-3 text-success" /> : <Minus className="size-3 text-muted-foreground" />}</div></div>;
      })}</div></div>;
}